import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      routing: {
        routes: {
          quickOrder: { paths: ['quick-order'] },
          orderDetails: {
            paths: ['order/:orderCode'],
            paramsMapping: { orderCode: 'erpOrderNumber' },
          },
        },
      },
    }),
  ],
})
export class QuickOrderRoutesModule {}
